import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import NervousLogo from './../../../images/nervouslogo.png'
import NervousPlusLogo from './../../../images/nervouspluslogo.png'
import NerveProLogo from './../../../images/nerveprologo.png'
import PlanBoxBackground from './../../../images/planboxbackground.png'
import pricingllines1 from './../../../images/pricingllines1.png'
import pricingllines2 from './../../../images/pricingllines2.png'
import pricingrlines1 from './../../../images/pricingrlines1.png'
import pricingrlines2 from './../../../images/pricingrlines2.png'
import QuestionaireClosedBg from './../../../images/questionaireclosedbg.png'
import N3rveLogo from "./../../../images/N3rveLogo.png"
import InviteOnlyLogo from './../../../images/inviteonlylogo.png'
import { Trans, useTranslation } from 'react-i18next'
import CheckCircle from './../../../images/checkcircle.png'
import './Pricing.css'
import ArrowDown from './../../../images/arrowdown.png'
import DisclaimerIcon from './../../../images/disclaimerpopup.png'
import ArtistDetailsCheckbox from './../../../images/artistdetailscheckbox.png'
import Cookies from 'universal-cookie';
import ComparePlanCheck from './../../../images/compareplancheck.png'
import AA from './../../../images/aa.png'
import Nervoustick from "./../../../images/nervoustick.png"
import Nerveplustick from "./../../../images/nerveplustick.png"
import Nerveprotick from "./../../../images/nerveprotick.png"
import nervediagonal from "./../../../images/nervediagonal.png"
import purplenexticon from "./../../../images/purplenexticon.png"
import Footer from '../../Footer/Footer';
import Questionaire from './../Artists/Questionaire';
import BtnTopLeft from './../../../images/btntopleft.png'
import BtnBottomRight from './../../../images/btnbottonright.png'
import QuestionareResultBg from './../../../images/questionaireresultbg.png'
import N3rvePlan from './../Artists/N3rvePlan';
import ArtistPgImg3 from './../../../images/artistpgimg3.png'
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import { logtoWix } from "../../Helpers/LogToWix";
import { useJwt, decodeToken } from "react-jwt";

function Pricing() {
  const [feedback, setFeedback] = useState(false)
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [disc1, setDisc1] = useState(false)
  const [disc2, setDisc2] = useState(false)
  const [disc3, setDisc3] = useState(false)
  const [disc4, setDisc4] = useState(false)
  const [disc5, setDisc5] = useState(false)
  const [disc6, setDisc6] = useState(false)
  const [disc7, setDisc7] = useState(false)
  const [disc8, setDisc8] = useState(false)
  const [disc9, setDisc9] = useState(false)
  const [disc10, setDisc10] = useState(false)
  const [questionaire, setQuestionaire] = useState(0);
  const cookies = new Cookies(null, { path: '/' });
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  })
  const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
  const questionaire_result = (data) => {
    setQuestionaire(data)
    return data
  }
  const hasLogged = useRef(false);

  const handleResize = () => {
    // console.log(window.innerWidth)
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  useEffect(() => {
    // topFunction()
    window.addEventListener("resize", handleResize, false);
    if (!hasLogged.current) {
      if (cookies.get('token') !== undefined) {
        if (decodeToken(cookies.get('token')) !== null) {
          logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Pricing Page", { "desc": "User opened the pricing page" })
          hasLogged.current = true;
        } else {
          logtoWix("anonymous user", "pageview", "Pricing Page", { "desc": "User opened the pricing page" })
          hasLogged.current = true;
        }
      } else {
        logtoWix("anonymous user", "pageview", "Pricing Page", { "desc": "User opened the pricing page" })
        hasLogged.current = true;
      }
    }
  }, []);

  return (
    <div style={{
      backgroundImage: 'linear-gradient(180deg, rgba(23,24,29,1) 79%, rgba(28,39,50,1) 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div className='PricingH1' style={{ marginTop: '3.75em', width: '80.63%', maxWidth: '20em', textAlign: 'center', position: 'relative' }}>
        <img src={pricingllines1} style={{ width: '206px', height: '1048.68px', position: 'absolute', left: '-206px', top: '-2em' }} />
        <img src={pricingrlines1} style={{ width: '118.93px', height: '1112px', position: 'absolute', right: '-118.93px', top: '0.5em' }} />Pricing</div>
      <div className='PricingH3' style={{ marginTop: '1.5em', width: '80.63%', maxWidth: '20em', textAlign: 'center' }}>Tailored plans that scales with your musical journey to match every stage.</div>

      {/* /** DESKTOP VIEW */}

      {
        dimensions.width >= 1024 &&
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '85.63%', alignSelf: 'center', position: 'relative' }}>



          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, backgroundSize: 'cover' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img className='PriceBoxLogo' src={NervousLogo} alt="Red 4 sided star" />
            </div>



            <div className='PriceBoxName' style={{ width: '100%' }}>{t('Nervous')}</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For the new artist</div>

            <div className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>{t('Free')}</div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Delivertosocial')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Limiteddsprelease')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Take90%royalty')}</div>
              </div>
            </div>

            <div className='GetStartedGreyBtn' onClick={() => navigate("/Signup")}>
              Get Started
            </div>

          </div>


          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, position: 'relative', backgroundSize: 'cover' }}>
            {/* <div className='MostPopularTxt' >
                                        MOST POPULAR
                                      </div> */}
            <div className="Mostpoptxt">
              MOST POPULAR
            </div>
            <img className='PriceBoxLogo' src={NervousPlusLogo} alt="Red 4 sided star" />

            <div className='PriceBoxName' style={{ width: '100%' }}>{t('Nervousplus')}</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For the rising artist</div>


            <span className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>
              <Trans i18nKey="Nervousplusprice">
                $19.99
                <span className='PriceBoxPriceYrTxt' style={{ marginTop: '5em' }}>/ year</span>
              </Trans></span>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>
                  <Trans i18nKey="Includeallbenefits" components={{ 1: <br /> }} >
                    Includes all benefits<br /> from N3RVous
                  </Trans>
                </div>

              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Brandyourself')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Take100%ofroyal')}</div>
              </div>
            </div>

            <div className='GetStartedRedBtn'>
              <div className="HoverOverlay" style={{ top: '0em', left: '0em' }} onClick={() => navigate("/Signup")} />
              Get Started
            </div>



          </div>

          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, backgroundSize: 'cover' }}>
            <img className='PriceBoxLogo' src={NerveProLogo} alt="Red 4 sided star" />

            <div className='PriceBoxName' style={{ width: '100%' }}>{t('Nervepro')}</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For the breakout artist</div>

            <span className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>
              <Trans i18nKey="Nerveproprice">
                $49.99
                <span className='PriceBoxPriceYrTxt'>/ year</span>
              </Trans></span>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'><Trans i18nKey="Includesallbenefits" components={{ 1: <br /> }} >
                  Includes all benefits<br /> from N3RVE
                </Trans></div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>Unlimited DSP Release</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Youtubemonetize')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'><Trans i18nKey="Exclusivebrand" components={{ 1: <br /> }} >
                  Exclusive Brand/Sync<br /> Deals
                </Trans></div>
              </div>
            </div>


            <div className='GetStartedRedBtn'>
              <div className="HoverOverlay" style={{ top: '0em', left: '0em' }} onClick={() => navigate("/Signup")} />
              Get Started
            </div>


          </div>

          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, backgroundSize: 'cover' }}>
            <img className='PriceBoxLogo' src={InviteOnlyLogo} alt="Red 4 sided star" />

            <div className='PriceBoxName' style={{ width: '100%' }}>NEXD</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For larger organizations</div>

            <span className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>
              Invite only
            </span>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>Includes all benefits fom N3RVE Premier</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>Audience Engagement</div>
              </div>


            </div>


            <div className='GetStartedGreyBtn' onClick={() => navigate("/support")}>
              Contact Us
            </div>


          </div>

        </div>
      }

      {
        dimensions.width >= 768 && dimensions.width < 1024 &&
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '98%', alignSelf: 'center', position: 'relative' }}>



          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, backgroundSize: 'cover', height: '40em' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img className='PriceBoxLogo' src={NervousLogo} alt="Red 4 sided star" />
            </div>



            <div className='PriceBoxName' style={{ width: '100%' }}>{t('Nervous')}</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For the new artist</div>

            <div className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>{t('Free')}</div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Delivertosocial')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Limiteddsprelease')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Take90%royalty')}</div>
              </div>
            </div>

            <div className='GetStartedGreyBtn' onClick={() => navigate("/Signup")}>
              Get Started
            </div>

          </div>


          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, position: 'relative', backgroundSize: 'cover', height: '40em' }}>
            {/* <div className='MostPopularTxt' >
                                        MOST POPULAR
                                      </div> */}
            <div className="Mostpoptxt">
              MOST POPULAR
            </div>
            <img className='PriceBoxLogo' src={NervousPlusLogo} alt="Red 4 sided star" />

            <div className='PriceBoxName' style={{ width: '100%' }}>{t('Nervousplus')}</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For the rising artist</div>


            <span className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>
              <Trans i18nKey="Nervousplusprice">
                $19.99
                <span className='PriceBoxPriceYrTxt' style={{ marginTop: '5em' }}>/ year</span>
              </Trans></span>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>
                  <Trans i18nKey="Includeallbenefits" components={{ 1: <br /> }} >
                    Includes all benefits<br /> from N3RVous
                  </Trans>
                </div>

              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Brandyourself')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Take100%ofroyal')}</div>
              </div>
            </div>

            <div className='GetStartedRedBtn'>
              <div className="HoverOverlay" style={{ top: '0em', left: '0em' }} onClick={() => navigate("/Signup")} />
              Get Started
            </div>



          </div>

          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, backgroundSize: 'cover', height: '40em' }}>
            <img className='PriceBoxLogo' src={NerveProLogo} alt="Red 4 sided star" />

            <div className='PriceBoxName' style={{ width: '100%' }}>{t('Nervepro')}</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For the breakout artist</div>

            <span className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>
              <Trans i18nKey="Nerveproprice">
                $49.99
                <span className='PriceBoxPriceYrTxt'>/ year</span>
              </Trans></span>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'><Trans i18nKey="Includesallbenefits" components={{ 1: <br /> }} >
                  Includes all benefits<br /> from N3RVE
                </Trans></div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>Unlimited DSP Release</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Youtubemonetize')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'><Trans i18nKey="Exclusivebrand" components={{ 1: <br /> }} >
                  Exclusive Brand/Sync<br /> Deals
                </Trans></div>
              </div>
            </div>


            <div className='GetStartedRedBtn'>
              <div className="HoverOverlay" style={{ top: '0em', left: '0em' }} onClick={() => navigate("/Signup")} />
              Get Started
            </div>


          </div>

          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, backgroundSize: 'cover', height: '40em' }}>
            <img className='PriceBoxLogo' src={InviteOnlyLogo} alt="Red 4 sided star" />

            <div className='PriceBoxName' style={{ width: '100%' }}>NEXD</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For larger organizations</div>

            <span className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>
              Invite only
            </span>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>Includes all benefits fom N3RVE Premier</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>Audience Engagement</div>
              </div>


            </div>


            <div className='GetStartedGreyBtn' onClick={() => navigate("/support")}>
              Contact Us
            </div>


          </div>

        </div>
      }

      {
        dimensions.width < 768 &&
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '98%', alignSelf: 'center', position: 'relative' }}>



          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, backgroundSize: 'cover', width: '70%' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img className='PriceBoxLogo' src={NervousLogo} alt="Red 4 sided star" />
            </div>



            <div className='PriceBoxName' style={{ width: '100%' }}>{t('Nervous')}</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For the new artist</div>

            <div className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>{t('Free')}</div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Delivertosocial')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Limiteddsprelease')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Take90%royalty')}</div>
              </div>
            </div>

            <div className='GetStartedGreyBtn' onClick={() => navigate("/Signup")}>
              Get Started
            </div>

          </div>


          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, position: 'relative', backgroundSize: 'cover', width: '70%' }}>
            {/* <div className='MostPopularTxt' >
                                        MOST POPULAR
                                      </div> */}
            <div className="Mostpoptxt">
              MOST POPULAR
            </div>
            <img className='PriceBoxLogo' src={NervousPlusLogo} alt="Red 4 sided star" />

            <div className='PriceBoxName' style={{ width: '100%' }}>{t('Nervousplus')}</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For the rising artist</div>


            <span className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>
              <Trans i18nKey="Nervousplusprice">
                $19.99
                <span className='PriceBoxPriceYrTxt' style={{ marginTop: '5em' }}>/ year</span>
              </Trans></span>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>
                  <Trans i18nKey="Includeallbenefits" components={{ 1: <br /> }} >
                    Includes all benefits<br /> from N3RVous
                  </Trans>
                </div>

              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Brandyourself')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '90%', alignItems: 'center', marginBottom: '0.5em' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Take100%ofroyal')}</div>
              </div>
            </div>

            <div className='GetStartedRedBtn'>
              <div className="HoverOverlay" style={{ top: '0em', left: '0em' }} onClick={() => navigate("/Signup")} />
              Get Started
            </div>



          </div>

          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, backgroundSize: 'cover', width: '70%' }}>
            <img className='PriceBoxLogo' src={NerveProLogo} alt="Red 4 sided star" />

            <div className='PriceBoxName' style={{ width: '100%' }}>{t('Nervepro')}</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For the breakout artist</div>

            <span className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>
              <Trans i18nKey="Nerveproprice">
                $49.99
                <span className='PriceBoxPriceYrTxt'>/ year</span>
              </Trans></span>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'><Trans i18nKey="Includesallbenefits" components={{ 1: <br /> }} >
                  Includes all benefits<br /> from N3RVE
                </Trans></div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>Unlimited DSP Release</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>{t('Youtubemonetize')}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'><Trans i18nKey="Exclusivebrand" components={{ 1: <br /> }} >
                  Exclusive Brand/Sync<br /> Deals
                </Trans></div>
              </div>
            </div>


            <div className='GetStartedRedBtn'>
              <div className="HoverOverlay" style={{ top: '0em', left: '0em' }} onClick={() => navigate("/Signup")} />
              Get Started
            </div>


          </div>

          <div className='PricingPlanBox' style={{ backgroundImage: `url(${PlanBoxBackground})`, backgroundSize: 'cover', width: '70%' }}>
            <img className='PriceBoxLogo' src={InviteOnlyLogo} alt="Red 4 sided star" />

            <div className='PriceBoxName' style={{ width: '100%' }}>NEXD</div>

            <div className='PriceBoxDesc' style={{ width: '100%' }}>For larger organizations</div>

            <span className='PriceBoxPrice' style={{ marginTop: '0.8em' }}>
              Invite only
            </span>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '90%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>Includes all benefits fom N3RVE Premier</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '0.5em', width: '90%' }}>
                <img style={{ height: '1.25em', width: '1.25em' }} src={CheckCircle} alt="Check mark" />
                <div className='CheckListItem'>Audience Engagement</div>
              </div>


            </div>


            <div className='GetStartedGreyBtn' onClick={() => navigate("/support")}>
              Contact Us
            </div>


          </div>

        </div>
      }


      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', paddingTop: '5em' }}>
        {/* <img className='PriceBoxLogo' src={InviteOnlyLogo} alt="Red 4 sided star" style={{marginLeft:'0em'}}/>

                        <div className='PriceBoxName' style={{width:'100%',marginLeft:'0em'}}>N3XD</div>
                        <div className='PriceBoxDesc' style={{maxWidth:'33em',textAlign:'center',marginLeft:'0em'}}>
                            Built for larger organizations who want to scale with confidence. 
                            Includes all benefits fom N3RVE Premier, plus Audience Engagement.
                        </div>

                        <div className='ContactUsBtn' onClick={()=>navigate("/support")}>
                            Contact Us
                        </div> */}

        <div style={{ display: "flex", flexDirection: 'row', marginBottom: '5em' }}>
          <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
          <div className="div" style={{ width: '1.05em', height: '0.125em', marginLeft: '0.5em' }} />
        </div>
      </div>

      {/* /******************************************/}




      {/* /** DESKTOP VIEW */}

      {
        dimensions.width >= 1024 &&
        <div style={{ width: '80.63%', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: '7.5em' }}>

          <div className='CompareFeaturesHeader'>
            {t('Compareallfeature')}
          </div>


          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center', marginTop: '2.5em', zIndex: '2', position: 'relative' }}>
            <img src={pricingllines2} style={{ width: '80px', height: '1495px', position: 'absolute', left: '-80px', top: '2em' }} />
            <img src={pricingrlines2} style={{ width: '101.72px', height: '1921px', position: 'absolute', right: '-101.72px', top: '0em' }} />

            <div style={{ display: 'flex', flexDirection: 'row', backgroundImage: `url(${AA})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', width: '90.07%', alignSelf: 'center', alignSelf: 'center' }}>
              <div style={{ width: '43%', height: '9.562em', backgroundImage: 'linear-gradient(144deg, rgba(204,204,255,0.08) 0%, rgba(204,204,255,0.04) 100%)', backgroundColor: '#1B1B22', backgroundRepeat: 'no-repeat', backgroundSize: '600%' }} />



              <div style={{ width: '19%', height: '9.562em', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundImage: 'linear-gradient(144deg, rgba(204,204,255,0.08) 0%, rgba(204,204,255,0.04) 100%)' }}>
                <img className='CompareLogo' src={NervousLogo} alt="Red 4 sided star" />
                <div className='ComparePlanNameM'>{t('Nervous')}</div>
                <div className='ComparePlanPriceM'>{t('Free')}</div>
              </div>

              <div style={{ width: '19%', height: '9.562em', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundImage: 'linear-gradient(144deg, rgba(204,204,255,0.08) 0%, rgba(204,204,255,0.04) 100%)', backgroundColor: '#1B1B22', backgroundRepeat: 'no-repeat', backgroundSize: '600%' }}>
                <img className='CompareLogo' src={NervousPlusLogo} alt="Purple 5 sided star" />
                <div className='ComparePlanNameM'>{t('Nervousplus')}</div>
                <div className='ComparePlanPriceM'> <Trans i18nKey="Nervousplusprice">
                  $19.99 / year
                </Trans></div>
              </div>

              <div style={{ width: '18.94%', height: '9.562em', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundImage: 'linear-gradient(144deg, rgba(204,204,255,0.08) 0%, rgba(204,204,255,0.04) 100%)' }}>
                <img className='CompareLogo' src={NerveProLogo} alt="Green 8 sided star" />
                <div className='ComparePlanNameM'>{t('Nervepro')}</div>
                <div className='ComparePlanPriceM'> <Trans i18nKey="Nerveproprice">
                  $49.99 / year
                </Trans></div>
              </div>

            </div>
          </div>


          <div className='TableHeaderM' style={{ width: '90.07%', alignSelf: 'center' }}>
            {t('Distribution')}
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxtM'>
              {t('Release')}
            </div>

            <div className='TableRowEntryM' style={{ width: '17.11%', paddingLeft: '0.9em', paddingRight: '0.5em', display: 'flex', flexDirection: 'column', paddingLeft: '0em', paddingRight: '0em', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <Trans i18nKey="2tracksperyear" components={{ 1: <br /> }} >
                2 tracks per<br /> year
              </Trans>
            </div>

            <div className='TableRowEntryM' style={{ width: '17.11%', display: 'flex', flexDirection: 'column', paddingLeft: '0em', paddingRight: '0em', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              {t('Unlimited')}
            </div>

            <div className='TableRowEntryM' style={{ width: '17.11%', display: 'flex', flexDirection: 'column', paddingLeft: '0em', paddingRight: '0em', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              {t('Unlimited')}
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('Distributetoplat')}
            </div>

            <div className='TableRowEntry' style={{ width: '16.91%', paddingLeft: '0.1%', paddingRight: '0.1%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              {t('35+plat')}
            </div>

            <div className='TableRowEntry' style={{ width: '16.91%', paddingLeft: '0.1%', paddingRight: '0.1%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              {t('150+plat')}
            </div>

            <div className='TableRowEntry' style={{ width: '16.91%', paddingLeft: '0.1%', paddingRight: '0.1%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              {t('150+plat')}
            </div>
          </div>



          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>

            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('Uniqueisrc')}


              <div style={{ position: 'relative' }}>
                {
                  disc1 &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-5.1em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Isrcandupc')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '12.5em' }} />
                  </div>
                }
                <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc1(true)} onMouseLeave={() => setDisc1(false)} />
              </div>
            </div>


            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>


          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('Timerelease')}

              <div style={{ position: 'relative' }}>
                {
                  disc2 &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-5.1em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Scheduletheexactdate')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '5.5em' }} />
                  </div>
                }
                <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc2(true)} onMouseLeave={() => setDisc2(false)} />
              </div>
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>

          <div className='TableHeaderM' style={{ width: '90.07%', alignSelf: 'center' }}>
            {t('Earnings')}
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('Revenue')}
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              80%
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              100%
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              100%
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', paddingLeft: '2em', paddingRight: '0em', MozBoxSizing: 'border-box', WebkitBoxSizing: 'border-box', boxSizing: 'border-box' }} className='TableRowtxt'>
              <Trans i18nKey="Splitearnings" components={{ 1: <br /> }} >
                Split earnings among<br /> collaborators.
              </Trans>
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>


          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('Youtuberevenue')}
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>


          </div>



          <div className='TableHeaderM' style={{ width: '90.07%', alignSelf: 'center' }}>
            {t('Digitaltools')}
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('Revenuereports')}
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('Analyticsandinsights')}
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('AIpowered')}
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              Creative tool kit <br /> & AI music assistant
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              Creative tool kit <br /> & AI music assistant
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '2em', paddingRight: '0em', MozBoxSizing: 'border-box', WebkitBoxSizing: 'border-box', boxSizing: 'border-box' }} className='TableRowtxt'>
              <Trans i18nKey="Premiumcreative" components={{ 1: <br /> }} >
                Premium Creative<br /> Services
              </Trans>

              <div style={{ position: 'relative' }}>
                {
                  disc3 &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-6.9em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Collaboratewithexclusivepart')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '9.1em' }} />
                  </div>
                }
                <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc3(true)} onMouseLeave={() => setDisc3(false)} />
              </div>
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>

          <div className='TableHeaderM' style={{ width: '90.07%', alignSelf: 'center' }}>
            {t('Marketing')}
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '2em', paddingRight: '0em', MozBoxSizing: 'border-box', WebkitBoxSizing: 'border-box', boxSizing: 'border-box' }} className='TableRowtxt'>
              {t('Verifiedartsup')}

              <div style={{ position: 'relative' }}>
                {
                  disc4 &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-6.9em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Getassistancetoattain')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '9.1em' }} />
                  </div>
                }
                <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc4(true)} onMouseLeave={() => setDisc4(false)} />
              </div>
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '2em', paddingRight: '0em', MozBoxSizing: 'border-box', WebkitBoxSizing: 'border-box', boxSizing: 'border-box' }} className='TableRowtxt'>
              <Trans i18nKey="Presavelineplace" components={{ 1: <br /> }} >
                Presave link <br /> procurement
              </Trans>

              <div style={{ position: 'relative' }}>
                {
                  disc5 && cookies.get('lang') === 'en' &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-6.9em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Getpresavelinkshassle')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '5.6em' }} />
                  </div>
                }

                {
                  disc5 && cookies.get('lang') === 'jp' &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-6.9em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Getpresavelinkshassle')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '7.4em' }} />
                  </div>
                }
                <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc5(true)} onMouseLeave={() => setDisc5(false)} />
              </div>
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '2em', paddingRight: '0em', MozBoxSizing: 'border-box', WebkitBoxSizing: 'border-box', boxSizing: 'border-box' }} className='TableRowtxt'>
              <Trans i18nKey="Youtubemarketingaddon" components={{ 1: <br /> }} >
                Youtube Marketing <br /> Add-On
              </Trans>

              <div style={{ position: 'relative' }}>
                {
                  disc6 && cookies.get('lang') === 'en' &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-6.9em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Exclusiveserviceaccess')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '10.9em' }} />
                  </div>
                }

                {
                  disc6 && cookies.get('lang') === 'jp' &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-6.9em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Exclusiveserviceaccess')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '9.2em' }} />
                  </div>
                }
                <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc6(true)} onMouseLeave={() => setDisc6(false)} />
              </div>
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('Brandsync')}

              <div style={{ position: 'relative' }}>
                {
                  disc7 && cookies.get('lang') === 'en' &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-5.1em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Unlockopportunity')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '7.3em' }} />
                  </div>
                }

                {
                  disc7 && cookies.get('lang') === 'jp' &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-5.1em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Unlockopportunity')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '5.6em' }} />
                  </div>
                }
                <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc7(true)} onMouseLeave={() => setDisc7(false)} />
              </div>
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('Exclusives')}

              <div style={{ position: 'relative' }}>
                {
                  disc8 && cookies.get('lang') === 'en' &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-5.1em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Accessexcusivesyncdeals')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '11em' }} />
                  </div>
                }
                {
                  disc8 && cookies.get('lang') === 'jp' &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-5.1em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Accessexcusivesyncdeals')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '11em' }} />
                  </div>
                }
                <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc8(true)} onMouseLeave={() => setDisc8(false)} />
              </div>
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              {t('Playlistsubmission')}

              <div style={{ position: 'relative' }}>
                {
                  disc9 && cookies.get('lang') === 'en' &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-5.1em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Wefacilitateplaylist')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '5.7em' }} />
                  </div>
                }

                {
                  disc9 && cookies.get('lang') === 'jp' &&
                  <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', bottom: '2.5em', marginLeft: '-5.1em' }}>
                    <div className='DisclaimerContainer'>
                      {t('Wefacilitateplaylist')}
                    </div>
                    <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '7.4em' }} />
                  </div>
                }
                <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc9(true)} onMouseLeave={() => setDisc9(false)} />
              </div>
            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0.25em', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '38.74%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '0em', paddingRight: '0em', textIndent: '1.71em' }} className='TableRowtxt'>
              Enhanced Marketing

              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc10(true)} onMouseLeave={() => setDisc10(false)} />

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '17.11%', paddingLeft: '0em', paddingRight: '0em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark" />
            </div>
          </div>
        </div>
      }

      {/* /******************************************/}



      {/* /** TABLET VIEW */}

      {
        dimensions.width >= 768 && dimensions.width < 1024 &&
        <div id="ComparePlanss" style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', paddingBottom: '5em', backgroundSize: 'cover' }}>
          <div className='CompareAllFeaturesTxt'>{t('Compareallfeature')}</div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '120%', justifyContent: 'center' }}>
            <div style={{ width: '18%', height: '9.562em', backgroundColor: 'rgba(0,0,0,9%)', backgroundImage: `url(${AA})`, backgroundSize: 'cover' }}>

            </div>

            <div style={{ width: '18%', height: '9.562em', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundImage: `url(${AA})`, backgroundImage: 'linear-gradient(144deg, rgba(204,204,255,0.08) 0%, rgba(204,204,255,0.04) 100%)' }}>
              <img className='CompareLogo' src={NervousLogo} alt="Red 4 sided star" />
              <div className='ComparePlanName'>{t('Nervous')}</div>
              <div className='ComparePlanPrice'>{t('Free')}</div>
            </div>

            <div style={{ width: '18%', height: '9.562em', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundImage: `url(${AA})`, backgroundColor: 'rgba(255,255,255,1%)', backgroundSize: 'cover' }}>
              <img className='CompareLogo' src={NervousPlusLogo} alt="Purple 5 sided star" />
              <div className='ComparePlanName'>{t('Nervousplus')}</div>
              <div className='ComparePlanPrice'> <Trans i18nKey="Nervousplusprice">
                $19.99
                <span className='PlanBoxPriceYrTxt'>/ year</span>
              </Trans></div>
            </div>

            <div style={{ width: '18%', height: '9.562em', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundImage: `url(${AA})`, backgroundImage: 'linear-gradient(144deg, rgba(204,204,255,0.08) 0%, rgba(204,204,255,0.04) 100%)' }}>
              <img className='CompareLogo' src={NerveProLogo} alt="Green 8 sided star" />
              <div className='ComparePlanName'>{t('Nervepro')}</div>
              <div className='ComparePlanPrice'> <Trans i18nKey="Nerveproprice">
                $49.99
                <span className='PlanBoxPriceYrTxt'>/ year</span>
              </Trans></div>
            </div>
          </div>

          <div className='TableHeader'>
            {t('Earnings')}
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center' }} className='TableRowtxt'>
              {t('Revenue')}
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              80%
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              100%
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              100%
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center' }} className='TableRowtxt'>
              <Trans i18nKey="Splitearnings" components={{ 1: <br /> }} >
                Split earnings among<br /> collaborators.
              </Trans>
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>


          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center' }} className='TableRowtxt'>
              {t('Youtuberevenue')}
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>


          </div>


          <div className='TableHeader'>
            {t('Distribution')}
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center' }} className='TableRowtxt'>
              {t('Release')}
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <Trans i18nKey="2tracksperyear" components={{ 1: <br /> }} >
                2 tracks per<br /> year
              </Trans>
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              {t('Unlimited')}
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              {t('Unlimited')}
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center' }} className='TableRowtxt'>
              {t('Distributetoplat')}
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              {t('35+plat')}
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              {t('150+plat')}
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              {t('150+plat')}
            </div>
          </div>



          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>

            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='TableRowtxt'>
              {t('Uniqueisrc')}
              {
                disc1 &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-15.2em', marginLeft: '-0.9em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Isrcandupc')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '12.5em' }} />
                </div>
              }
              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc1(true)} onMouseLeave={() => setDisc1(false)} />
            </div>


            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>


          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='TableRowtxt'>
              {t('Timerelease')}
              {
                disc2 &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-8.2em', marginLeft: '-0.95em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Scheduletheexactdate')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '5.5em' }} />
                </div>
              }
              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc2(true)} onMouseLeave={() => setDisc2(false)} />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>





          <div className='TableHeader'>
            {t('Digitaltools')}
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center' }} className='TableRowtxt'>
              {t('Revenuereports')}
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center' }} className='TableRowtxt'>
              {t('Analyticsandinsights')}
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center' }} className='TableRowtxt'>
              {t('AIpowered')}
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              Creative tool kit <br /> & AI music assistant
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              Creative tool kit <br /> & AI music assistant
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='TableRowtxt'>
              <Trans i18nKey="Premiumcreative" components={{ 1: <br /> }} >
                Premium Creative<br /> Services
              </Trans>
              {
                disc3 &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-12em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Collaboratewithexclusivepart')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '9.1em' }} />
                </div>
              }
              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc3(true)} onMouseLeave={() => setDisc3(false)} />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>

          <div className='TableHeader'>
            {t('Marketing')}
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='TableRowtxt'>
              {t('Verifiedartsup')}
              {
                disc4 &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-12em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Getassistancetoattain')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '9.1em' }} />
                </div>
              }
              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc4(true)} onMouseLeave={() => setDisc4(false)} />

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='TableRowtxt'>
              <Trans i18nKey="Presavelineplace" components={{ 1: <br /> }} >
                Presave link <br /> procurement
              </Trans>
              {
                disc5 && cookies.get('lang') === 'en' &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-8.5em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Getpresavelinkshassle')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '5.6em' }} />
                </div>
              }

              {
                disc5 && cookies.get('lang') === 'jp' &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-10em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Getpresavelinkshassle')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '7.4em' }} />
                </div>
              }
              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc5(true)} onMouseLeave={() => setDisc5(false)} />

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='TableRowtxt'>
              <Trans i18nKey="Youtubemarketingaddon" components={{ 1: <br /> }} >
                Youtube Marketing <br /> Add-On
              </Trans>
              {
                disc6 && cookies.get('lang') === 'en' &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-13.7em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Exclusiveserviceaccess')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '10.9em' }} />
                </div>
              }

              {
                disc6 && cookies.get('lang') === 'jp' &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-11.7em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Exclusiveserviceaccess')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '9.2em' }} />
                </div>
              }
              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc6(true)} onMouseLeave={() => setDisc6(false)} />

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='TableRowtxt'>
              {t('Brandsync')}
              {
                disc7 && cookies.get('lang') === 'en' &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-10.1em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Unlockopportunity')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '7.3em' }} />
                </div>
              }

              {
                disc7 && cookies.get('lang') === 'jp' &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-8.5em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Unlockopportunity')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '5.6em' }} />
                </div>
              }
              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc7(true)} onMouseLeave={() => setDisc7(false)} />

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='TableRowtxt'>
              {t('Exclusives')}
              {
                disc8 && cookies.get('lang') === 'en' &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-13.8em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Accessexcusivesyncdeals')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '11em' }} />
                </div>
              }
              {
                disc8 && cookies.get('lang') === 'jp' &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-13.8em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Accessexcusivesyncdeals')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '11em' }} />
                </div>
              }
              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc8(true)} onMouseLeave={() => setDisc8(false)} />

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='TableRowtxt'>
              {t('Playlistsubmission')}
              {
                disc9 && cookies.get('lang') === 'en' &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-8.6em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Wefacilitateplaylist')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '5.7em' }} />
                </div>
              }

              {
                disc9 && cookies.get('lang') === 'jp' &&
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', marginTop: '-10.1em', marginLeft: '-1em' }}>
                  <div className='DisclaimerContainer'>
                    {t('Wefacilitateplaylist')}
                  </div>
                  <img src={ArrowDown} style={{ width: '1.5em', height: '1em', position: 'absolute', left: '6.9em', top: '7.4em' }} />
                </div>
              }
              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc9(true)} onMouseLeave={() => setDisc9(false)} />

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '0.25em', justifyContent: 'center' }}>
            <div style={{ width: '18%', backgroundColor: 'rgba(0,0,0,9%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='TableRowtxt'>
              Enhanced Marketing

              <img src={DisclaimerIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '1.78em' }} onMouseOver={() => setDisc10(true)} onMouseLeave={() => setDisc10(false)} />

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,1%)' }}>

            </div>

            <div className='TableRowEntry' style={{ width: '18%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)' }}>
              <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark" />
            </div>
          </div>



        </div>
      }

      {/* /******************************************/}



      {/* /** MOBILE VIEW */}

      {
        dimensions.width < 768 &&
        <div id="ComparePlans" style={{ width: '100%', overflowY: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', paddingBottom: '5em' }}>
          <div className='CompareAllFeaturesTxt' style={{ fontSize: '1.75em', fontWeight: '500', textAlign: 'center', width: '80%', lineHeight: '120.1%', marginTop: '1.5em' }}>{t('Compareallfeature')}</div>

          <div style={{ backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)', width: '90%', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '1.5em', paddingBottom: '1.5em', paddingBottom: '2em' }}>
            <img src={NervousLogo} style={{ width: '1.27em', height: '1.27em' }} />
            <div className='PlanNameMobile'>N3RVous</div>
            <div className='PlanPriceMobile'>Free</div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '70%' }}>
              <div className='PlanInfoHeaderMobile'>
                EARNINGS
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nervoustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>80% Revenue</div>
              </div>

              <div className='PlanInfoHeaderMobile'>
                DISTRIBUTIONS
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nervoustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Release 2 tracks per year</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nervoustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Distribute to 35+ platforms</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nervoustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Unique ISRC & UPC</div>
              </div>

              <div className='PlanInfoHeaderMobile'>
                DIGITAL TOOLS
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nervoustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Revenue reports</div>
              </div>

            </div>
          </div>

          <div style={{ backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)', width: '90%', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '1.5em', paddingBottom: '1.5em', marginTop: '1.5em', paddingBottom: '2em' }}>
            <img src={NervousPlusLogo} style={{ width: '1.27em', height: '1.27em' }} />
            <div className='PlanNameMobile'>N3RVE Plus</div>
            <div className='PlanPriceMobile'>$19.99 / year</div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '70%' }}>
              <div className='PlanDisclaimerMobile'>
                in addition to the N3RVE Free, you’ll receive these additional benefits.
              </div>
              <div className='PlanInfoHeaderMobile'>
                EARNINGS
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>100% Revenue</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Split earnings among collaborators.</div>
              </div>

              <div className='PlanInfoHeaderMobile'>
                DISTRIBUTIONS
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Unlimited Release</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>︎Distribute to 150+ platforms</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Time release</div>
              </div>

              <div className='PlanInfoHeaderMobile'>
                MARKETING & PROMOTION
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Youtube Marketing Add-On</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Presave link procurement</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>“Verified Artist” support</div>
              </div>

              <div className='PlanInfoHeaderMobile'>
                DIGITAL TOOLS
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Revenue reports</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Analytics & insights</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>AI-powered Artist Suite</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveplustick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Premium Creative Services</div>
              </div>

            </div>
          </div>

          <div style={{ backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)', width: '90%', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '1.5em', paddingBottom: '1.5em', marginTop: '1.5em', paddingBottom: '2em' }}>
            <img src={NerveProLogo} style={{ width: '1.27em', height: '1.27em' }} />
            <div className='PlanNameMobile'>N3RVE Pro</div>
            <div className='PlanPriceMobile'>$49.99 / year</div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '70%' }}>
              <div className='PlanDisclaimerMobile'>
                in addition to the N3RVE Plus, you’ll receive these additional benefits.
              </div>
              <div className='PlanInfoHeaderMobile'>
                EARNINGS
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveprotick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>︎Youtube Revenue Boost</div>
              </div>


              <div className='PlanInfoHeaderMobile'>
                DISTRIBUTIONS
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveprotick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Everything in Plus plan</div>
              </div>

              <div className='PlanInfoHeaderMobile'>
                MARKETING & PROMOTION
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveprotick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Brand & sync rights</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveprotick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Exclusives</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.8em' }}>
                <img src={Nerveprotick} style={{ width: '0.9em', height: '1.1em' }} />
                <div className='PlanInfoMobile'>Playlist Submission</div>
              </div>



            </div>
          </div>

        </div>
      }


      {/* {
                        questionaire===1 &&
                        <div className='QuestionaireOpenContainer' style={{ backgroundImage:`url(${QuestionareOpenBg})`, backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',height:'34.62em'}}>
                          <Questionaire  func={questionaire_result}/>
                        </div>
                      }

                      {
                        questionaire===0 &&
                        <div style={{paddingTop:'7.5em',paddingBottom:'11.5em',overflow:'hidden',position:'relative',display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}>
                      <img src={nervediagonal} style={{position:'absolute',zIndex:'1'}}/>
                      <div className='PricingH1' style={{marginBottom:'1.3em',marginTop:'2.5em',zIndex:'2',width:'80%' ,alignSelf:'center',textAlign:'center'}}>Not sure which plan is the best fit for you?</div>

                    <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap' ,zIndex:'2',justifyContent:'center'}}>

                        <div style={{display:'flex',flexDirection:'column'}} className='PricingOptionsBox'>
                            <div className='PricingH2'>Take the Quiz</div>
                            <div className='PricingH3' style={{marginTop:'1em',marginBottom:'2em',width:'80%'}}>Get a recommended plan in just one minute.</div>
                            <div style={{display:'flex',flexDirection:'row',textAlign:'center',cursor:'pointer'}}>
                                <div className='PricingH3' style={{color:'#C7A5FF'}} onClick={()=>setQuestionaire(1)}>Get Started</div>
                                <img src={purplenexticon} style={{marginLeft:'0.5em'}}/>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column'}} className='PricingOptionsBox'>
                            <div className='PricingH2'>Contact Us</div>
                            <div className='PricingH3' style={{marginTop:'1em',marginBottom:'2em',width:'80%'}}>Work with a N3RVE team member to match with a plan perfect for your needs. </div>
                            <div style={{display:'flex',flexDirection:'row',textAlign:'center',cursor:'pointer'}}>
                                <div className='PricingH3' style={{color:'#C7A5FF'}} onClick={()=>navigate("/support")}>Continue</div>
                                <img src={purplenexticon} style={{marginLeft:'0.5em'}}/>
                            </div>
                        </div>
                    </div>

                </div>

                          
                      }


                      {
                        questionaire===2 &&
                        <div className='QuestionaireResultContainer' style={{ backgroundImage:`url(${QuestionareResultBg})`, 
                        height:'49.5em',
                        // height:'50px',
                        width:'100%',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        backgroundSize:'cover'}}>
                          <N3rvePlan/>
                        </div>
                      } */}
      {
        questionaire === 1 &&
        <div className='QuestionaireOpenContainer' style={{
          backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/o9esrivi2zkjvmom8ph7")`, backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat', height: '40.62em', width: '100%'
        }}>
          <Questionaire func={questionaire_result} />
        </div>
      }

      {
        questionaire === 0 &&
        <div style={{ paddingTop: '7.5em', paddingBottom: '11.5em', overflow: 'hidden', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <img src={nervediagonal} style={{ position: 'absolute', zIndex: '1' }} />
          <div className='PricingH1' style={{ marginBottom: '1.3em', marginTop: '2.5em', zIndex: '2', width: '80%', alignSelf: 'center', textAlign: 'center' }}>Not sure which plan is the best fit for you?</div>

          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', zIndex: '2', justifyContent: 'center' }}>

            <div style={{ display: 'flex', flexDirection: 'column' }} className='PricingOptionsBox'>
              <div className='PricingH2'>Take the Quiz</div>
              <div className='PricingH3' style={{ marginTop: '1em', marginBottom: '2em', width: '80%' }}>Get a recommended plan in just one minute.</div>
              <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', cursor: 'pointer' }}>
                <div className='PricingH3' style={{ color: '#C7A5FF' }} onClick={() => setQuestionaire(1)}>Get Started</div>
                <img src={purplenexticon} style={{ marginLeft: '0.5em' }} />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }} className='PricingOptionsBox'>
              <div className='PricingH2'>Contact Us</div>
              <div className='PricingH3' style={{ marginTop: '1em', marginBottom: '2em', width: '80%' }}>Work with a N3RVE team member to match with a plan perfect for your needs. </div>
              <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', cursor: 'pointer' }}>
                <div className='PricingH3' style={{ color: '#C7A5FF' }} onClick={() => navigate("/support")}>Continue</div>
                <img src={purplenexticon} style={{ marginLeft: '0.5em' }} />
              </div>
            </div>
          </div>

        </div>

      }


      {
        questionaire === 2 &&
        <div className='QuestionaireResultContainer' style={{
          backgroundImage: `url(${ArtistPgImg3})`,
          height: '70.5em',
          // height:'50px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundSize: 'cover'
        }}>
          <N3rvePlan />
        </div>
      }

      <div style={{ width: '100%' }}>
        <Footer />
      </div>
    </div>
  )
}

export default Pricing;


